export default [
  {
    name: 'Perfis',
    path: 'perfis',
    component: () => import('@/views/perfis/Index.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [{ name: 'Administração', path: '/administracao' }, { name: 'Perfis de Usuários' }]
    }
  },
  {
    name: 'Perfis Editar',
    path: 'perfis/edit/:id',
    component: () => import('@/views/perfis/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Perfis de Usuários', path: '/administracao/perfis' },
        { name: 'Editar' }
      ]
    }
  },
  {
    name: 'Perfis Adicionar',
    path: 'perfis/edit',
    component: () => import('@/views/perfis/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Perfis de Usuários', path: '/administracao/perfis' },
        { name: 'Adicionar' }
      ]
    }
  }
];
